// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "babel-polyfill"

Vue.config.productionTip = false

import $ from 'jquery'

// 引入Axios
import Axios from 'axios'
Vue.config.productionTip = false
Vue.prototype.$axios = Axios

// 引入element-UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 封装axios方法
import request from "./utils/request.js";
Vue.prototype.$get = request.getRequest;

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js